import GameCard from 'components/game/GameCard';
import React, {useEffect, useState} from 'react';
import SvgText from 'components/SvgText';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {FormattedMessage, useIntl} from 'react-intl';
import * as PropTypes from 'prop-types';
import {ACTION_TYPE, CARD_NAME, cardSetting} from '../GameRule';
import {getCardDescription} from "./CardContent";
import {Tooltip} from "@material-ui/core";

const LOG_TYPE = {
  CARD_USE: 'CARD_USE',
  USE_PREPARE: 'USE_PREPARE',
  STATUS_CHANGE: "STATUS_CHANGE",
  TURN_OVER: 'TURN_OVER',
  PREPARE_BE_ATK: 'PREPARE_BE_ATK',
  PREPARE_TURN_STEP: 'PREPARE_TURN_STEP',
};

const CardNameDisplay = (props) => {
  const { cardName } = props;
  const intl = useIntl();
  const setting = cardSetting[cardName];
  const { type: cardType } = setting || {};
  let title = getCardDescription(cardName, setting, intl);
  return (<Tooltip title={title}>
    <span className={`log-card-name log-card-name-${cardName} log-card-type-${cardType}`}>
    <FormattedMessage
      id={`game.GamePage.card.name.${cardName}`}
      defaultMessage={cardName}
    />
  </span>
  </Tooltip>);
}

function OneLogLine(props) {
  const { playerName, cardName, stName, change, logType } = props;
  return (<div className='one-log-line'>
    {(logType === LOG_TYPE.CARD_USE || logType === LOG_TYPE.USE_PREPARE) && <>
      <FormattedMessage
        id={`game.GamePage.log.type.${logType}`}
        values={{
          cardName: <CardNameDisplay cardName={cardName}/>,
          playerName,
        }}
      />
    </>}
    {logType === LOG_TYPE.STATUS_CHANGE && <>
      {playerName}
      的
      {stName}{change > 0 ? '增加了' : '减少了'}{Math.abs(change)}
    </>}
    {logType === LOG_TYPE.TURN_OVER && <>
      <FormattedMessage
        id={`game.GamePage.log.type.${logType}`}
        defaultMessage={'{name}结束回合'}
        values={{ name: playerName }}
      />
    </>}
    {logType === LOG_TYPE.PREPARE_BE_ATK && <>
      <FormattedMessage
        id={`game.GamePage.log.type.${logType}`}
        defaultMessage={'触发了备战卡：{name}，{description}'}
        values={{
          name: <CardNameDisplay cardName={cardName}/>, description: <FormattedMessage
            id={`game.GamePage.log.prepare.${logType}.${cardName}`}
            defaultMessage={'震惊！'}
          />
        }}
      />
    </>}
    {logType === LOG_TYPE.PREPARE_TURN_STEP && <>
      <FormattedMessage
        id={`game.GamePage.log.type.${logType}`}
        defaultMessage={'备战卡自动弃置：{name}，{description}'}
        values={{
          name: <CardNameDisplay cardName={cardName}/>,
          playerName: playerName,
          description: <FormattedMessage
            id={`game.GamePage.log.prepare.${logType}.${cardName}`}
            defaultMessage={'居然。'}
          />
        }}
      />
    </>}
  </div>);
}

OneLogLine.propTypes = {
  playerName: PropTypes.any,
  cardName: PropTypes.any,
};
const LogDisplay = (props) => {
  const { G, ctx, players } = props;
  const { log = {} } = G;
  const { lastActions = [], lastActionCount } = log;
  const lastAction = lastActions[lastActions.length - 1] || {};
  console.log("lastAction=", lastAction);
  const { playersStatus } = lastAction;

  const [logs, setLogs] = useState([]);

  // 最后一张牌
  useEffect(() => {
    // When initial state username is not null, submit the form to load repos
    //
    // lastActions.forEach(action => {
    //   const { playerID: lastActionPlayerID, card: lastCard = null, playersStatus, actionCount: lastActionCount } = action;
    // })

    setLogs((logs) => {
      const lastLog = logs[logs.length - 1] || {};
      const { actionCount: logLastActionCount = 0 } = lastLog;
      console.log("logLastActionCount", logLastActionCount, logs, lastActions);
      const newLogs = lastActions
        .filter(({ actionCount }) => actionCount > logLastActionCount)
        .map(action => {
          const {
            playerID: lastActionPlayerID,
            card: lastCard = null,
            playersStatus,
            actionCount,
            actionType
          } = action;
          const cardName = lastCard?.name;
          let playerName = null;
          if (players[lastActionPlayerID]) playerName = players[lastActionPlayerID].info.name;
          const actionInfos = { playerName, cardName, actionCount };
          switch (actionType) {
            case ACTION_TYPE.TURN_OVER: {
              return { ...actionInfos, logType: LOG_TYPE.TURN_OVER };
            }
            case ACTION_TYPE.PREPARE_BE_ATK: {
              return { ...actionInfos, logType: LOG_TYPE.PREPARE_BE_ATK };
            }
            case ACTION_TYPE.PREPARE_TURN_STEP: {
              return { ...actionInfos, logType: LOG_TYPE.PREPARE_TURN_STEP };
            }
            case ACTION_TYPE.USE_PREPARE: {
              return { ...actionInfos, logType: LOG_TYPE.USE_PREPARE };
            }
            case ACTION_TYPE.NONE: {
              return { ...actionInfos, logType: LOG_TYPE.NONE };
            }
            default:
              return { ...actionInfos, logType: LOG_TYPE.CARD_USE };
          }

        });

      return [...logs, ...newLogs]
    });
  }, [lastActionCount]);

  const [lastStatus, setLastStatus] = useState(null);
  useEffect(() => {
    // When initial state username is not null, submit the form to load repos
    if (lastStatus && playersStatus) {

      // 使用卡名

      let newLogs = [];
      // 对比得到数值变化
      playersStatus.forEach((player, playerIdx) => {
        const { members } = player;
        members.forEach((member, memberIdx) => {
          const { status } = member;
          const { hp, atk, def } = status;
          const oldStatus = lastStatus[playerIdx].members[memberIdx].status; // 简单的按idx获取，后续可能会需要改为更准确的获取方式。或者重做更好的log系统
          const stNames = ['hp', 'atk', 'def', 'walk'];
          stNames.forEach(stName => {
            if (status[stName] !== oldStatus[stName]) {
              console.log("status change", status[stName], oldStatus[stName], stName, status, oldStatus);

              let playerName = player.info.name;
              if (players[playerIdx]) playerName = players[playerIdx].info.name;

              newLogs.push({
                playerName,
                stName,
                change: status[stName] - oldStatus[stName],
                logType: LOG_TYPE.STATUS_CHANGE,
              });
            }
          });
        });
      });
      setLogs((logs) => {
        const lastLog = logs[logs.length - 1] || {};
        const { actionCount: lastLogActionCount = 0 } = lastLog;
        newLogs = newLogs.map((log, idx) => {
          // if (!log) return log;
          const actionCount = log?.actionCount || lastLogActionCount + idx * 0.001;
          return { ...log, actionCount }
        })
        return [...logs, ...newLogs];
      });
    }
    setLastStatus(playersStatus);
  }, [playersStatus]);


  const displayLogs = [...logs].reverse();
  return (
    <div className="log-display">
      {displayLogs.map((log, idx) => {
        const { playerName, cardName, stName, change, logType } = log;
        return (
          // <Typography variant="h4" key={idx}>
          <OneLogLine {...log} key={idx}/>
          // </Typography>
        )
      })}
    </div>
  );
};

export default LogDisplay;
